<div class="submit-dialog" *ngIf="!isLoading">
  <div class="icon-circle">
    <img src="assets/images/library_add_check.svg" alt="Submit Icon" />
  </div>

  <h2 class="title">Ready to submit your quiz?</h2>
  <p class="subtitle">Once submitted, your answers cannot be changed or undone</p>

  <div class="actions">
    <button class="btn-cancel" (click)="closeDialog()">Go to Questions</button>
    <button class="btn-submit" (click)="submitQuiz()">Submit Quiz</button>
  </div>
</div>